export default function lowestChecklistItemRankForChecklist (state, getters) {
  return (checklistId) => {
    const item = getters.lowestRankedChecklistItemForChecklist(checklistId)
    return item ? item.rank : ''
  }
}
